import React, { useState } from 'react';
import { Send } from 'lucide-react';

export default function MessageInput({ onSend, onTyping, disabled }) {
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim() || sending || disabled) return;
    setSending(true);
    await onSend(text.trim());
    setText('');
    setSending(false);
  };

  const handleChange = (e) => {
    setText(e.target.value);
    onTyping?.();
  };

  return (
    <form onSubmit={handleSubmit} className="px-6 py-4 flex gap-3" style={{borderTop:'1px solid var(--border-color)'}}>
      <input
        value={text}
        onChange={handleChange}
        placeholder="Ecrivez un message..."
        className="input-field flex-1 !rounded-full !py-3"
        data-testid="chat-input"
      />
      <button
        type="submit"
        disabled={!text.trim() || sending || disabled}
        className="w-12 h-12 rounded-full bg-gradient-to-r from-brand-purple to-brand-violet flex items-center justify-center hover:scale-105 transition-transform disabled:opacity-50 shrink-0"
        data-testid="chat-send-btn"
      >
        <Send size={18} className="text-white" />
      </button>
    </form>
  );
}
